import { ILuggageStatusRequest, ILuggageStatusResponse, IResponse } from "@common/models";
import Api, { IOptions } from "@service/Api";
import { Action } from "./Proxy";

export function checkLuggageStatus<T = ILuggageStatusRequest, U = ILuggageStatusResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Bms/GetStatus", { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
    }
    return Promise.reject();
}